/**
 * Every string the signature screen shows (USR-13).
 *
 * **The clickwrap statement is not here**, and that is the point of the whole
 * feature: the server owns its text and the screen renders exactly what
 * `GET /me/signature` returned. A copy of it in this file would be a second
 * wording free to disagree with the one the acceptance is recorded against.
 *
 * Sentence case, no emoji, calm and procedural — the reader is about to sign a
 * court filing.
 */
export const SIGNATURE_COPY = {
  title: 'Your signature',
  /** Shown only when this screen was reached from a document's sign button. */
  backToDocument: 'Back to document',
  intro:
    'Draw your signature once and it is stored on your account. You can replace or remove it whenever you like.',

  pad: {
    label: 'Draw your signature',
    hint: 'Use a mouse, a finger, or a pen.',
    clear: 'Clear',
    /** Announced when the pad has ink, so a screen reader is not left guessing. */
    drawn: 'Signature drawn',
    empty: 'Nothing drawn yet',
  },

  clickwrap: {
    heading: 'What you are agreeing to',
    accept: 'I agree',
    /** Shown when the stored acceptance is older than the current statement. */
    stale:
      'This agreement has changed since you last accepted it. Read it again and accept the current version.',
  },

  save: {
    action: 'Save signature',
    working: 'Saving',
    replace: 'Replace signature',
    /** Why the button is inert, said rather than left to be guessed at. */
    needsInk: 'Draw your signature before saving.',
    needsAccept: 'Accept the agreement before saving.',
  },

  stored: {
    heading: 'Stored signature',
    accepted: (when: string) => `Agreed ${when}`,
    since: (when: string) => `On your account since ${when}`,
    alt: 'Your stored signature',
    remove: 'Remove signature',
    removing: 'Removing',
    confirm: 'Remove it?',
    confirmYes: 'Remove',
    confirmNo: 'Keep it',
  },

  states: {
    loading: 'Loading your signature',
  },

  errors: {
    load: 'Your signature could not be loaded.',
    save: 'That signature could not be saved.',
    remove: 'That signature could not be removed.',
    retry: 'Try again',
  },
} as const;
